const triageL18n = {
	'triage.left.prefix': 'HOLA,',
	'triage.left.title': 'Empecemos con algunas preguntas',
	'triage.fields.appointmentOwner.prefix': '1 DE 4',
	'triage.fields.appointmentOwner.label': '¿Para quién es la consulta?',
	'triage.fields.appointmentOwner.forMe': 'PARA MÍ',
	'triage.fields.appointmentOwner.forSomeoneElse': 'ALGUIEN MÁS',
	'triage.fields.discomfortLvl.prefix': '2 DE 4',
	'triage.fields.discomfortLvl.label': '¿Qué tan fuerte es el malestar?',
	'triage.fields.discomfortLvl.strong': 'MUY FUERTE',
	'triage.fields.discomfortLvl.strong.helpText': 'Me quita la tranquilidad',
	'triage.fields.discomfortLvl.moderate': 'MODERADO',
	'triage.fields.discomfortLvl.moderate.helpText': 'Por ahora puedo manejarlo',
	'triage.fields.discomfortLvl.slight': 'LEVE',
	'triage.fields.discomfortLvl.slight.helpText': 'Es una molestia reciente',
	'triage.fields.discomfortDescription.prefix': '3 DE 4',
	'triage.fields.discomfortDescription.label': 'De acuerdo, describe el malestar:',
	'triage.fields.discomfortDescription.placeholder': 'Escribe aquí tu respuesta',
	'triage.fields.discomfortDuration.prefix': '4 DE 4',
	'triage.fields.discomfortDuration.label': '¿Hace cuánto tiempo se viene presentando este malestar?',
	'triage.fields.discomfortDuration.placeholder': 'Escribe aquí tu respuesta',
	'triage.validations.appointmentOwner.required': 'Selecciona una opción',
	'triage.validations.discomfortLvl.required': 'Selecciona una opción',
	'triage.validations.discomfortDescription.required': 'Ingresa la descripción de tu malestar',
	'triage.validations.discomfortDuration.required': 'Ingresa la duración de tu malestar',
	'triage.submit.label': 'Enviar',
	'triage.disclosure.firstLine': 'La información que acabas de declarar ha sido guardada de manera segura.',
	'triage.disclosure.secondLine': 'Al dar enviar, recomendaremos las opciones disponibles.',
};

export default triageL18n;
